// extracted by mini-css-extract-plugin
module.exports = {"input":"radio_input-module__input--3Bu5R"};